





































import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppCheckRound from '@/components/AppCheckRound.vue'
import AppRouterLink from '@/components/AppRouterLink.vue'

import { OrderMixin } from '@/mixins'
import { CartItem } from '@/interfaces'

@Component({
  components: {
    AppRouterLink,
    AppCheckRound
  }
})
export default class extends Mixins(OrderMixin) {
  @Prop() readonly cartItem!: CartItem
  @Prop() readonly cartItemQuantity!: number
  @Prop() readonly cartItemSelected!: boolean

  get cartItemImagePath () {
    return this.cartItem.item.medias.length > 0
      ? this.cartItem.item.medias[0].path
      : undefined
  }

  get cartItemOptionString () {
    const options = this.cartItem.itemVariant.optionValues.map(optionValue =>
      optionValue.optionValue).concat(`수량 ${this.cartItemQuantity}개`)
    return options.join(' / ')
  }

  get total () {
    return (this.cartItem.item.price + this.cartItem.itemVariant.additionalAmount) * this.cartItemQuantity
  }
}
